import { NextPageContext } from 'next';
import { setCookie, parseCookies } from 'nookies';
import { v4 as uuidv4 } from 'uuid';

export const ACTIVE_SESSION_COOKIE_NAME = 'active_session';

// todo: remove once our supported browsers list matches Crypto.randomUUID()
const genUUID = (): string => {
    if ('crypto' in window) {
        if ('randomUUID' in window.crypto) {
            return window.crypto.randomUUID();
        }
    }
    return uuidv4().replace(/-/g, '');
};

const getHostDomain = (hostname = '') => {
    const parsedHostname = hostname.match(/([\w-]+\.(co\.uk|com|dev))(:\d+)?$/);
    if (parsedHostname) {
        return parsedHostname[1];
    }
    return '';
};

/**
 * Set active session cookie
 */
export const setActiveSession = (val?: string) => {
    const randomId = val ?? genUUID();
    const domain = getHostDomain(window?.location?.hostname);
    // mirror same options as secure session cookie so that it expires at the same time
    setCookie(null, ACTIVE_SESSION_COOKIE_NAME, randomId, {
        domain,
        path: '/',
        secure: true
    });
    return randomId;
};

export const getActiveSessionIdentifier = () => {
    const cookies = parseCookies();
    if (ACTIVE_SESSION_COOKIE_NAME in cookies) {
        return cookies[ACTIVE_SESSION_COOKIE_NAME];
    }
    return undefined;
};

export const requestSessionType = (
    req: NextPageContext['req']
): 'anon' | 'activeUserSession' | undefined => {
    const cookies = parseCookies({ req });
    if (ACTIVE_SESSION_COOKIE_NAME in cookies) {
        return cookies[ACTIVE_SESSION_COOKIE_NAME] === 'anon'
            ? 'anon'
            : 'activeUserSession';
    }
    return;
};
